// pages/HowToTeachList.js
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchWithAuth } from '../auth';
import Breadcrumbs from '../components/Breadcrumbs';

const topicTypes = [
  { value: 'MISHNA', label: 'משנה', imageKey: 'mishna' },
  { value: 'GMARA', label: 'גמרא', imageKey: 'gmara' },
  { value: 'HALACHA', label: 'הלכה', imageKey: 'halacha' },
];

export default function HowToTeachList() {
  const [topicImages, setTopicImages] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        const disciplinesRes = await fetchWithAuth('/api/disciplines/');
        if (disciplinesRes.ok) {
          const disciplines = await disciplinesRes.json();
          const toshbaDiscipline = disciplines.find(d => d.name.includes('תושב"ע'));
          
          if (toshbaDiscipline) {
            const imagesRes = await fetchWithAuth(`/api/disciplines/${toshbaDiscipline.id}/toshba-how-to-teach-topic-images/`);
            if (imagesRes.ok) {
              const imagesData = await imagesRes.json();
              if (!ignore) setTopicImages(imagesData);
            }
          }
        }
      } catch (err) {
        console.error('Error loading topic images:', err);
      } finally {
        if (!ignore) setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, []);

  return (
    <div className="page-wrapper">
      <Breadcrumbs
        items={[
          { to: '/disciplines', label: 'תחומי דעת' },
          { to: '/toshba/classes', label: 'תושב"ע' },
          { label: 'הכנה למבחן מפמ"ר' },
        ]}
      />

      <div className="toolbar-center">
        <h2 className="text-2xl md:text-3xl font-bold text-secondary-900 dark:text-white">
          הכנה למבחן מפמ"ר
        </h2>
      </div>

      <p className="text-center mt-2 mb-6">
        <Link
          to="/toshba/classes"
          className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
        >
          חזרה לתושב"ע
        </Link>
      </p>

      <div className="grid-autofit">
        {topicTypes.map(topic => {
          const imageUrl = topicImages[topic.imageKey];
          return (
          <article
            key={topic.value}
            className="group bg-white dark:bg-secondary-800 rounded-2xl shadow-card overflow-hidden transition-all duration-300 hover:shadow-card-hover hover:-translate-y-1"
          >
            <Link
              to={`/toshba/how-to-teach/${topic.value}`}
              className="block relative overflow-hidden bg-secondary-100 dark:bg-secondary-700"
              style={{ aspectRatio: '3/2' }}
            >
                {imageUrl ? (
                <img
                    src={imageUrl}
                  alt={topic.label}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <svg className="w-16 h-16 text-secondary-300 dark:text-secondary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
              )}
            </Link>

            <div className="p-4 md:p-5">
              <h3 className="text-lg font-semibold text-secondary-900 dark:text-white mb-1 text-center">
                <Link
                  to={`/toshba/how-to-teach/${topic.value}`}
                  className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                >
                  {topic.label}
                </Link>
              </h3>
              <p className="text-sm text-secondary-500 dark:text-secondary-400">
                לחצו כדי להיכנס
              </p>
            </div>
          </article>
        );
        })}
      </div>
    </div>
  );
}
